import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "../StatusCard";
import { MetricCard } from "../MetricCard";
import { HealthBadge } from "../HealthBadge";
import { QueryStateBoundary } from "../QueryStateBoundary";
import { useCertificationReport } from "@/hooks/queries/useCertificationReport";

interface ScenarioResult {
  scenario_name: string;
  status: string;
}

interface CertificationReportPayload {
  generated_at: string;
  overall_passed: boolean;
  scenario_results: ScenarioResult[];
}

export function CertificationSection(): React.JSX.Element {
  const reportQuery = useCertificationReport();

  return (
    <StatusCard title="Certification">
      <QueryStateBoundary query={reportQuery}>
        {(payload) => {
          const report = payload as unknown as CertificationReportPayload;
          const productionReadinessScenario = report.scenario_results.find(
            (s) => s.scenario_name === "production_readiness",
          );
          return (
            <Stack spacing={1.5}>
              <MetricCard
                label="Backend Certification Status"
                render={<HealthBadge status={report.overall_passed ? "passed" : "failed"} />}
              />
              <MetricCard
                label="Production Readiness"
                render={<HealthBadge status={productionReadinessScenario?.status ?? null} />}
              />
              <MetricCard label="Certification Timestamp" value={report.generated_at} />
            </Stack>
          );
        }}
      </QueryStateBoundary>
    </StatusCard>
  );
}
